var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarningHex = function SvgWarningHex(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 13.5a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 1 0 3 0v-6a1.5 1.5 0 0 0-1.5-1.5Zm0 12a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm14.56-11.16-7.9-7.9A1.58 1.58 0 0 0 26.59 6H15.4c-.4 0-.77.16-1.06.43l-7.9 7.91c-.28.29-.43.67-.44 1.06v11.2c0 .4.16.77.43 1.06l7.91 7.9c.29.28.67.43 1.06.44h11.2c.4 0 .77-.16 1.06-.44l7.9-7.9c.28-.29.43-.67.44-1.07V15.4c0-.4-.16-.77-.44-1.06ZM33 25.97 25.96 33h-9.93L9 25.96v-9.93L16.04 9h9.93L33 16.04v9.93Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarningHex);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warningHex.abc14611c8820210d42f4ec69a0640d8.svg";